<div class="form-group mb-10">
    <label class="control-label col-xs-9">
        {{ "control_additional_button_effect" | translate }}
    </label>
    <div class="col-xs-3 control-switch text-right">
        <sp-switch [active]="isActive()" (toggleActiveEvent)="setIsActive($event)" />
    </div>
</div>

@if (isActive()) {
    <div class="well">
        <div class="form-group mb-20">
            <label class="col-xs-12">
                {{ "control_additional_button_effect_condition" | translate }}
            </label>
            <div class="col-xs-12">
                <select class="form-control" (change)="setEffectCondition($event)">
                    <option [value]="EEffectCondition.hover" [selected]="effectCondition() === EEffectCondition.hover">
                        {{ "option_additional_button_effect_condition_hover" | translate }}
                    </option>
                    <option
                        [value]="EEffectCondition.static"
                        [selected]="effectCondition() === EEffectCondition.static"
                    >
                        {{ "option_additional_button_effect_condition_static" | translate }}
                    </option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label class="col-xs-12">
                {{ "control_additional_button_effect_type" | translate }}
            </label>
            @if (effectCondition() === EEffectCondition.hover) {
                <div class="col-xs-12">
                    <select class="form-control" (change)="setHoverEffects($event)">
                        <option [value]="EHoverEffects.bounce" [selected]="hoverEffects() === EHoverEffects.bounce">
                            {{ "option_additional_button_effect_type_bounce" | translate }}
                        </option>
                        <option [value]="EHoverEffects.shake" [selected]="hoverEffects() === EHoverEffects.shake">
                            {{ "option_additional_button_effect_type_shake" | translate }}
                        </option>
                        <option [value]="EHoverEffects.decrease" [selected]="hoverEffects() === EHoverEffects.decrease">
                            {{ "option_additional_button_effect_type_decrease" | translate }}
                        </option>
                        <option [value]="EHoverEffects.increase" [selected]="hoverEffects() === EHoverEffects.increase">
                            {{ "option_additional_button_effect_type_increase" | translate }}
                        </option>
                    </select>
                </div>
            }
            @if (effectCondition() === EEffectCondition.static) {
                <div class="col-xs-12">
                    <select class="form-control" (change)="setStaticEffects($event)">
                        <option [value]="EStaticEffects.shine" [selected]="staticEffects() === EStaticEffects.shine">
                            {{ "option_additional_button_effect_type_shine" | translate }}
                        </option>
                        <option
                            [value]="EStaticEffects.twinkle"
                            [selected]="staticEffects() === EStaticEffects.twinkle"
                        >
                            {{ "option_additional_button_effect_type_twinkle" | translate }}
                        </option>
                    </select>
                </div>
            }
        </div>
    </div>
}
